<template>
  <section class="article-block-skeleton skeleton-block">
    <div class="title-wrapper">
      <Skeleton />
      <Skeleton />
    </div>
    <div class="cards-wrapper">
      <ArticleCardSkeleton v-for="index in 3" :key="`article-skeleton-${index}`" />
    </div>
  </section>
</template>

<script setup lang="ts">
import ArticleCardSkeleton from '~/components/components/article/skeleton/ArticleCardSkeleton.vue';
import Skeleton from '~/components/components/skeleton/Skeleton.vue';
</script>

<style lang="scss" scoped>
.article-block-skeleton {
  > .title-wrapper {
    display: flex;
    margin-bottom: 16px;
  }

  > .title-wrapper > .skeleton {
    height: 16px;
    width: 100px;
    border-radius: $border-radius-l;

    &:first-of-type {
      width: 40px;
      margin-right: 8px;
    }
  }

  > .cards-wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: 172px;
    gap: 16px;
    overflow: hidden;
    max-width: 100%;

    @include tablet {
      grid-template-columns: repeat(2, 80%);
      overflow: auto;
      padding-bottom: 16px;
      margin-bottom: -16px;
      margin-right: -40px;
    }

    @include mobile {
      grid-template-columns: repeat(4, 90%);
      grid-auto-rows: 144px;
      margin-right: -16px;
    }
  }

  > .cards-wrapper > .skeleton {
    border-radius: $border-radius-l;
  }
}
</style>
